import { Component, OnInit } from '@angular/core';
import { AuctionService, LottoService, MarketplaceService } from '@fgb/core';
import { zip } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';
@Component({
  selector: 'fgb-rewards-page',
  templateUrl: './rewards-page.component.html',
  styleUrls: ['./rewards-page.component.scss'],
})
export class RewardsPageComponent implements OnInit {
  populations = Populations;

  constructor(
    private marketplaceService: MarketplaceService,
    private lottoService: LottoService,
    private auctionService: AuctionService
  ) {}
  showOffCanvas: boolean = false;

  ngOnInit() {
    zip(
      this.auctionService.fetchAuctions(),
      this.lottoService.fetchLottos(),
      this.marketplaceService.fetchMarketplaceItems()
    ).toPromise();
  }
}
